import { inboxService } from '@/services'
import { SHARED_LOADING, SHARED_UNLOADING } from '@/store/shared.module'
import { SESSION, SHARED } from '@/constants/constants'
import router from '@/router'
import { ROUTE_NAME } from '@/constants/route.constants'

//define module name
const MODULE_NAME = 'inbox/'

const A_GET_INBOX_MSG = 'getInboxMsg'
const A_GET_INBOX_MSG_CONTENT = 'getInboxMsgContent'
const A_READ_INBOX_MSG = 'readInboxMsg'
const A_READ_BULK_INBOX_MSG = 'readBulkInboxMsg'
const A_DELETE_INBOX_MSG = 'deleteInboxMsg'
const A_GET_UNREAD_INBOX_MSG = 'getUnreadInboxMsg'
const A_GET_EXCLUSIVE_BONUS_FT = 'getExclusiveBonusFt'
const A_READ_EXCLUSIVE_BONUS_FT = 'readExclusiveBonusFt'
const A_WS_ADD_NOTIFICATION = 'wsAddNotification'

export const INBOX_GET_MSG = MODULE_NAME + A_GET_INBOX_MSG
export const INBOX_GET_MSG_CONTENT = MODULE_NAME + A_GET_INBOX_MSG_CONTENT
export const INBOX_READ_MSG = MODULE_NAME + A_READ_INBOX_MSG
export const INBOX_DELETE_MSG = MODULE_NAME + A_DELETE_INBOX_MSG
export const INBOX_READ_BULK_MSG = MODULE_NAME + A_READ_BULK_INBOX_MSG
export const INBOX_GET_UNREAD_MSG = MODULE_NAME + A_GET_UNREAD_INBOX_MSG
export const INBOX_GET_EXCLUSIVE_BONUS_FT = MODULE_NAME + A_GET_EXCLUSIVE_BONUS_FT
export const INBOX_READ_EXCLUSIVE_BONUS_FT = MODULE_NAME + A_READ_EXCLUSIVE_BONUS_FT
export const INBOX_WS_ADD_NOTIFICATION = MODULE_NAME + A_WS_ADD_NOTIFICATION

const M_GET_INBOX_MSG = 'setInboxMsg'
const M_GET_INBOX_MSG_CONTENT = 'setInboxMsgContent'
const M_READ_INBOX_MSG = 'setReadInboxMsg'
const M_DELETE_INBOX_MSG = 'setDeleteInboxMsg'
const M_GET_UNREAD_INBOX_MSG = 'setUnreadInboxMsg'
const M_GET_EXCLUSIVE_BONUS_FT = 'setExclusiveBonusFt'
const M_READ_EXCLUSIVE_BONUS_FT = 'setReadExclusiveBonusFt'
const M_WS_ADD_NOTIFICATION = 'wsAddNotificationItem'

const state = {
  inboxMsg: [],
  inboxMsgContent: [],
  readInboxMsg: {},
  readBulkInboxMsg: {},
  deleteInboxMsg: {},
  inboxUnreadMsg: {},
  exclusiveBonusFt: { list: [] },
  readExclusiveBonusFt: {},
}

//to retrieve data from store state (called by component)
const getters = {}

//to perform some actions related with updating state (called by component)
const actions = {
  [A_GET_INBOX_MSG]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    inboxService.getInboxMsg().then(
      data => {
        let result = data
        commit(M_GET_INBOX_MSG, { result })
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      error => {
        let result = error
        commit(M_GET_INBOX_MSG, { result })
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      }
    )
  },
  async [A_GET_INBOX_MSG_CONTENT]({ dispatch, commit } , { obj }) {
    let language = obj.language
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    await inboxService.getInboxMsgContent(obj).then(
        data => {
          let result = data
          commit(M_GET_INBOX_MSG_CONTENT, { language, result })
          dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        },
        error => {
          let result = error
          commit(M_GET_INBOX_MSG_CONTENT, { language, result })
          dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        }
    )
  },
  [A_READ_INBOX_MSG]({ dispatch, commit }, { obj }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    inboxService.readInboxMsg(obj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      }
    )
  },
  [A_READ_BULK_INBOX_MSG]({ dispatch, commit }, { obj }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    inboxService.readBulkInboxMsg(obj).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      }
    )
  },
  async [A_DELETE_INBOX_MSG]({ dispatch, commit }, { payload }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    await inboxService.deleteInboxMsg(payload).then(
      data => {
        let result = data
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      },
      error => {
        let result = error
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
      }
    )
  },
  [A_GET_UNREAD_INBOX_MSG]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    inboxService.getUnreadInboxMsg().then(
        data => {
          let result = data
          commit(M_GET_UNREAD_INBOX_MSG, { result })
          dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        },
        error => {
          let result = error
          commit(M_GET_UNREAD_INBOX_MSG, { result })
          dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        }
    )
  },
  [A_GET_EXCLUSIVE_BONUS_FT]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })
    inboxService.getExclusiveBonusFt().then(
        data => {
          let result = data
          commit(M_GET_EXCLUSIVE_BONUS_FT, { result })
          dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        },
        error => {
          let result = error
          commit(M_GET_EXCLUSIVE_BONUS_FT, { result })
          dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        }
    )
  },
  [A_READ_EXCLUSIVE_BONUS_FT]({ dispatch, commit }, { obj }) {
    inboxService.readExclusiveBonusFt(obj).then(
        data => {
          let result = data
          dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        },
        error => {
          let result = error
          dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        }
    )
  },
  [A_WS_ADD_NOTIFICATION]({ commit }, item) {
    commit(M_WS_ADD_NOTIFICATION, item)
  },
}

//to update state values (called by actions)
const mutations = {
  [M_GET_INBOX_MSG](state, { result }) {
    if (result.success) {
      state.inboxMsg = result.data
    }
  },
  [M_GET_INBOX_MSG_CONTENT](state, { language, result }) {
    // if (result.success) {
    //   state.inboxMsgContent = result.data
    // }

    let p = []

    if (result.success) {
      let inbox = result.data
      let subject = inbox.subject
      let message = inbox.message
      let content = inbox.content
      let bonusId = inbox.bonus_id ?? 0
      let bonusType = inbox.bonus_type ?? 0

      let localizationData = inbox.localization;
      if (typeof localizationData === "string") {
        try {
          localizationData = JSON.parse(localizationData);
        } catch (error) {
          console.error("Error parsing localization JSON:", error);
          localizationData = [];
        }
      }
      let objLocale = Array.isArray(localizationData) ? localizationData[0] : null;

      if (objLocale && Array.isArray(localizationData)) {
        const localizedItem = localizationData.find(x => x.languageCode === language);
        if (localizedItem) {
          objLocale = localizedItem;
          subject = objLocale.subject;
          message = objLocale.message;
          content = objLocale.content;
        }
      }

      p = {
        subject: subject,
        message: message,
        content: content,
        bonusId: bonusId,
        bonusType: bonusType
      };
    }
    state.inboxMsgContent = p
  },
  [M_GET_UNREAD_INBOX_MSG](state, { result }) {
    if (result.success) {
      state.inboxUnreadMsg = result.data.unread_count
    }
  },
  [M_GET_EXCLUSIVE_BONUS_FT](state, { result }) {
    if (result.success) {
      state.exclusiveBonusFt = result.data
    }
  },
  [M_READ_EXCLUSIVE_BONUS_FT](state, { result }) {
    if (result.success) {
      state.readExclusiveBonusFt = result.data
    }
  },
  [M_WS_ADD_NOTIFICATION](state, item) {
    const exists = state.exclusiveBonusFt.list.some(m => m.id === item.id)
    if (!exists) {
      state.exclusiveBonusFt.list = [item, ...state.exclusiveBonusFt.list]
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
